import { render, staticRenderFns } from "./TipoRegraSelector.vue?vue&type=template&id=a9c141bc&scoped=true"
import script from "./TipoRegraSelector.vue?vue&type=script&lang=js"
export * from "./TipoRegraSelector.vue?vue&type=script&lang=js"
import style0 from "./TipoRegraSelector.vue?vue&type=style&index=0&id=a9c141bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c141bc",
  null
  
)

export default component.exports